import { CommonModule } from '@angular/common';
import {Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import moment from "moment/moment";
import {Prestazione} from "../../models/prestazione.model";
import {PrenotazioneService} from "../../services/prenotazione.service";
import {of, switchMap} from "rxjs";
import {Prenotazione} from "../../models/prenotazione.model";
import Swal from "sweetalert2";

interface ngAfterViewInit {
}

@Component({
  selector: 'app-prenotazione-edit',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  ],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.css'
})
export class EditComponent implements OnDestroy{
  @Input() isVisible: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  durata: number = 30;
  minuti: number[] = Array.from({length: this.durata}, (_, i) => i + 1);
  private _prestazione: Prestazione | null = null;

  @Input()
  set prestazione(prestazione: Prestazione | null) {
    this._prestazione = prestazione;
    if (prestazione && prestazione.durata) {
      this.durata = prestazione.durata;
      this.minuti = Array.from({length: this.durata}, (_, i) => i + 1);
    }
    if (prestazione && prestazione.tempoMedio) {
      this.tempoMedio = prestazione.tempoMedio;
    }
  }

  get prestazione(): Prestazione | null {
    return this._prestazione;
  }

  nome: any;
  cognome: any;
  cellulare: any;
  prezzo: any;
  note: any;
  tempoMedio: any;
  timer: any;
  abbonamento: any;
  isUser: any;
  private _prenotazione: Prenotazione | null = null;


  @Input()
  set prenotazione(prenotazione: Prenotazione | null) {
    this._prenotazione = prenotazione;
    if (prenotazione) {
      this.nome = prenotazione.nome;
      this.cognome = prenotazione.cognome;
      this.cellulare = prenotazione.cellulare;
      this.prezzo = prenotazione.prezzo;
      this.note = prenotazione.note;
      this.tempoMedio = prenotazione.tempoMedio?? this.tempoMedio;
      this.timer = prenotazione.timer;
      this.abbonamento = prenotazione.abbonamento;
      this.isUser = prenotazione.isUser;

      this.startTimerInterval();
    }
  }

  get prenotazione(): Prenotazione | null {
    return this._prenotazione;
  }

  @Input() hour: number = 9;
  @Input() minutes: number = 20;

  constructor(public prenotazioneService: PrenotazioneService, private cd: ChangeDetectorRef) {
  }

  // Mette in maiuscolo l'input
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }

  onClose() {
    this.closeModal.emit();
  }

  onSave(form: NgForm) {
    if(
      form.invalid ||
      this._prenotazione === null ||
      this._prenotazione._id === null
    ) {
      console.log("Form invalid")
      return;
    }

    this._prenotazione.nome = this.nome;
    this._prenotazione.cognome = this.cognome;
    this._prenotazione.cellulare = this.cellulare;
    this._prenotazione.prezzo = this.prezzo;
    this._prenotazione.note = this.note;
    this._prenotazione.tempoMedio = this.tempoMedio;
    this._prenotazione.abbonamento = this.abbonamento;
    this._prenotazione.isUser = this.isUser;

    this.prenotazioneService.updatePrenotazione(this._prenotazione._id,  this._prenotazione,)
      .pipe(
        switchMap((response) => {
          console.log("Prenotazione aggiornata", response);
          form.resetForm();
          this.closeModal.emit();
          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          console.error("Errore nell'aggiornamento della prenotazione", error);

          Swal.fire({
            icon: 'error',
            title: 'Ops...',
            text: "Errore nell'aggiornamento della prenotazione",
            confirmButtonColor: '#050A30'
          });

        }
      });

  }

  onStartTimer() {
    this.timer = moment().format('YYYY-MM-DD HH:mm:ss');

    // @ts-ignore
    this.prenotazioneService.updateTimer(this.prenotazione._id,this.timer)
      .pipe(
        switchMap((response) => {
          console.log("Timer partito", response);
          this.startTimerInterval();
          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          console.error("Errore nella creazione del timer della prenotazione", error);
        }
      });
  }

  timerInterval: any;
  startTimerInterval() {
    this.timerInterval = setInterval(() => {
      this.cd.markForCheck(); // Aggiungi questa riga
    }, 1000);
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  onDelete() {
    // @ts-ignore
    this.prenotazioneService.deletePrenotazione(this.prenotazione._id,)
      .pipe(
        switchMap((response) => {
          console.log("Prenotazione eliminata", response);
          this.closeModal.emit();
          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          console.error("Errore nella eliminazione della prenotazione", error);

          Swal.fire({
            icon: 'error',
            title: 'Ops...',
            text: "Errore nell'eliminazione della prenotazione",
            confirmButtonColor: '#050A30'
          });

        }
      });
  }

  deletePrenotazione(){
    Swal.fire({
      title: "Sei sicuro di voler eliminare l'appuntamento?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#FF2E77",
      cancelButtonColor: "#050A30",
      confirmButtonText: "Elimina comunque",
      cancelButtonText: "Non eliminare",
    }).then((result) => {
      if (result.isConfirmed) {
        this.onDelete();
      }
    });
  }

  getTimePassed(): string {
  if (this.timer) {
    const now = moment();
    const timerDate = moment(this.timer);
    const duration = moment.duration(now.diff(timerDate));
    const minutes = Math.floor(duration.asMinutes());
    const seconds = Math.floor(duration.asSeconds()) % 60;

    if(this.durata > minutes) {
      return `${minutes} minuti e ${seconds} secondi`;
    }else {
      return `${this.durata} minuti e 0 secondi`;
    }
  }
  return '';
}

}
